import { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

@inject(stores => ({ model: stores.liveClassModel }))
@observer
class ParticipantCompletion extends Component {
  render() {
    const { store } = this.props.model;

    const { isRoomConnected, isTeacher } = store;

    if (!isRoomConnected || !isTeacher) {
      return null;
    }

    const { cardId, children } = this.props;
    const { progressSync, participants } = store;
    const { totalLearners } = participants;
    const cardCompletionInfo = progressSync.completionInfoByCardId[cardId];

    // TODO: Accessing promise-based observable values like
    // participants.learnerUsers,
    // cardCompletionInfo.completedUsers,
    // cardCompletionInfo.incompleteUsers needs to be
    // updated so that they can be fetched lazilly

    if (!cardCompletionInfo) {
      return children({
        completedCount: 0,
        incompleteCount: totalLearners,
        totalCount: totalLearners,
        completedLearners: [],
        incompleteLearners: participants.learnerUsers.value
      });
    }

    return children({
      completedCount: cardCompletionInfo.completedUserIds.length,
      incompleteCount: cardCompletionInfo.incompleteUserIds.length,
      totalCount: totalLearners,
      completedLearners: cardCompletionInfo.completedUsers.value,
      incompleteLearners: cardCompletionInfo.incompleteUsers.value
    });
  }
}

ParticipantCompletion.propType = {
  cardId: PropTypes.string.isRequired
};

export default ParticipantCompletion;
